<template>
  <div
    id="loading_container"
    :class="loadingContainerClass"
  >
    <!-- INLINE SVG + LOADING DOTS -->
    <div class="splash-content" v-if="!longLoad && !isInitError && !cognitoError">
      <div id="svg-loading">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 143.98 89.1"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Logo"><path class="cls-1" d="M103.85,61.15a2.15,2.15,0,0,0-1.62.21h0a2.11,2.11,0,0,0-1,2.51,35.72,35.72,0,0,1-9.55,6.66,1,1,0,0,0-.46,1.3,1,1,0,0,0,1.31.47,38.17,38.17,0,0,0,5.53-3.25,37.68,37.68,0,0,0,4.57-3.81l.07,0a2.15,2.15,0,0,0,1.62-.21h0a2.15,2.15,0,0,0,.78-2.92A2.09,2.09,0,0,0,103.85,61.15Z" /><path class="cls-1" d="M90.75,5.46a36.19,36.19,0,0,1,5.78,3.22,35.32,35.32,0,0,1,4.73,3.89,2.14,2.14,0,0,0,0,1.18h0a2.1,2.1,0,0,0,1,1.29l0,0a2.2,2.2,0,0,0,1.58.19h0a2.14,2.14,0,0,0,1.29-1h0a2.08,2.08,0,0,0,.21-1.61,2.14,2.14,0,0,0-1-1.3h0a2.13,2.13,0,0,0-1.61-.21l-.1,0a37.37,37.37,0,0,0-11.1-7.51,1,1,0,1,0-.8,1.79Z" /><path class="cls-1" d="M67.2,58.16a21.87,21.87,0,0,0,24.19-4,2.13,2.13,0,0,0,.71.13,2.13,2.13,0,1,0,0-4.26,2.13,2.13,0,0,0-1.5.62l0,0A2.11,2.11,0,0,0,90,52.12h0a2.05,2.05,0,0,0,.09.56,20.23,20.23,0,0,1-6.11,4,20.18,20.18,0,0,1-14.06.45,4,4,0,0,0,.82-1,4.11,4.11,0,0,0,.55-2A16.66,16.66,0,0,0,88.08,50a1,1,0,0,0,0-1.39,1,1,0,0,0-1.39,0l-.31.3a14.69,14.69,0,0,1-15.87,2.81,4.14,4.14,0,0,0-1.3-1.19l-.06,0a4,4,0,0,0-1.61-.5c-.32-.24-.64-.5-.94-.77a14.63,14.63,0,0,1-4.79-8.72L61.75,40a1,1,0,0,0-1.1-.86,1,1,0,0,0-.85,1.1,16.55,16.55,0,0,0,5.31,10.26A4,4,0,0,0,63.62,52l0,.06a3.87,3.87,0,0,0-.43,1.14,19.76,19.76,0,0,1-4.6-5.89,1,1,0,0,0-1.32-.42,1,1,0,0,0-.43,1.32,22.13,22.13,0,0,0,6.79,7.84,4.08,4.08,0,0,0,1.52,1.54h0A4,4,0,0,0,67.2,58.16Zm-2.1-3.54A2.19,2.19,0,0,1,65.29,53a.05.05,0,0,0,0,0,2.13,2.13,0,0,1,1.3-1,2.11,2.11,0,0,1,1.57.18l0,0a2.11,2.11,0,0,1,1,1.29,2.12,2.12,0,0,1-1.51,2.61,2,2,0,0,1-1.61-.21h0A2.16,2.16,0,0,1,65.1,54.62Z" /><path class="cls-1" d="M92.85,66.72a4.07,4.07,0,0,0,1.43-5.55,4,4,0,0,0-2.48-1.92,4.1,4.1,0,0,0-3.1.41h0a4.19,4.19,0,0,0-1.35,1.26A24.89,24.89,0,0,1,82,62.81a1,1,0,1,0,.44,1.92,27.19,27.19,0,0,0,4.21-1.35,4.1,4.1,0,0,0,.5,1.81l.08.14a4.3,4.3,0,0,0,.9,1l-.15.06a30.46,30.46,0,0,1-9.86,2.25,4.11,4.11,0,0,0-3.62,0c-.81-.05-1.6-.12-2.38-.23A31.39,31.39,0,0,1,68,67.6a1,1,0,0,0-1.21.68,1,1,0,0,0,.68,1.21,33,33,0,0,0,4.36.9l.81.11a4.11,4.11,0,0,0-.44,1.86h0a4.1,4.1,0,0,0,.27,1.45,35.53,35.53,0,0,1-16-5.8,2.14,2.14,0,0,0,0-.91,2.11,2.11,0,0,0-1-1.29l0,0a2.15,2.15,0,0,0-2.87.81l0,0a2.13,2.13,0,0,0-.18,1.58,2.09,2.09,0,0,0,1,1.29h0a2.11,2.11,0,0,0,1.62.21,2.6,2.6,0,0,0,.36-.13,37.5,37.5,0,0,0,9.32,4.55,38,38,0,0,0,9.71,1.8,4.13,4.13,0,0,0,4,0c1.33-.08,2.64-.22,3.94-.42a38.2,38.2,0,0,0,5.79-1.4,1,1,0,1,0-.61-1.86A34.86,34.86,0,0,1,82,73.57c-.59.1-1.2.18-1.81.24a4.1,4.1,0,0,0,.27-1.45A4,4,0,0,0,80,70.5a32.61,32.61,0,0,0,8.77-2.26q1-.43,2-.93a4.17,4.17,0,0,0,2-.51Zm-15,7.14a2.11,2.11,0,0,1-1.51.62,2.07,2.07,0,0,1-1.5-.62h0a2.12,2.12,0,0,1-.62-1.51h0a2.13,2.13,0,0,1,.58-1.46l0,0a2.08,2.08,0,0,1,1.5-.63,2.13,2.13,0,0,1,2.13,2.13A2.16,2.16,0,0,1,77.82,73.86Zm14-8.81h0a2.14,2.14,0,0,1-2.91-.78h0a2.13,2.13,0,0,1-.21-1.61,2.17,2.17,0,0,1,1-1.3h0a2.13,2.13,0,0,1,3.13,2.4A2.09,2.09,0,0,1,91.81,65.05Z" /><path class="cls-1" d="M44.34,51l.12,0a4.07,4.07,0,0,0,1.62-.89,31.74,31.74,0,0,0,3,5.74A33.41,33.41,0,0,0,52,59.7a4.13,4.13,0,0,0,2.88,2.88,32.55,32.55,0,0,0,5.48,3.89,2.11,2.11,0,0,0,1.06,1.9h0a2.07,2.07,0,0,0,1.62.21,2.09,2.09,0,0,0,1.29-1h0a2.11,2.11,0,0,0-.73-2.88l-.11-.07a2.13,2.13,0,0,0-1.56-.17,2.07,2.07,0,0,0-.62.29,29.68,29.68,0,0,1-3.63-2.41,4.4,4.4,0,0,0,1.18-.82l0-.07a4,4,0,0,0,1-1.61,27,27,0,0,0,16.49,5.58l.69,0,.69,0a1,1,0,1,0-.1-2l-.64,0h-.64a25.16,25.16,0,0,1-16.53-6.17,4.1,4.1,0,0,0-1-1.55h0a4.1,4.1,0,0,0-1.55-1,25.16,25.16,0,0,1-6.17-16.53c0-.92.05-1.83.14-2.73a4,4,0,0,0,1.26.58h0a4,4,0,0,0,2,0c-.06.7-.1,1.4-.1,2.12a22,22,0,0,0,.17,2.7,21.67,21.67,0,0,0,.49,2.65A1,1,0,0,0,57,43.1a19,19,0,0,1-.45-2.41,19.82,19.82,0,0,1-.15-2.46,19.59,19.59,0,0,1,.3-3.45,4.16,4.16,0,0,0,.91-3.4,20,20,0,0,1,4.63-7.26c.31-.31.63-.6,1-.89a4.41,4.41,0,0,0,.45,1.19h0a4,4,0,0,0,1.49,1.49,16.66,16.66,0,0,0-5.17,9.32,1,1,0,0,0,1.93.34c.07-.36.15-.72.24-1.07A14.62,14.62,0,0,1,66.92,27c.2-.16.41-.33.62-.48a4.15,4.15,0,0,0,1.67-.54l.06,0a4.11,4.11,0,0,0,1.24-1.14,14.55,14.55,0,0,1,4.57-1.14c.41,0,.82-.05,1.23-.05a14.93,14.93,0,0,1,3.44.4,14.61,14.61,0,0,1,2.18.71,15.43,15.43,0,0,1,2.14,1.1,15.61,15.61,0,0,1,2,1.52,2.26,2.26,0,0,0-.09.58A2.15,2.15,0,0,0,88.1,30a2.12,2.12,0,0,0,1.51-.63l0,0a2.1,2.1,0,0,0,.58-1.46,2.15,2.15,0,0,0-.62-1.51h0a2.15,2.15,0,0,0-1.51-.62,2.09,2.09,0,0,0-.69.12,16.44,16.44,0,0,0-11.1-4.27,16.83,16.83,0,0,0-5,.78,4.05,4.05,0,0,0-.55-2h0a4.27,4.27,0,0,0-.82-1A20.11,20.11,0,0,1,84,19.79l.77.34A4.16,4.16,0,0,0,86,21.31l.15.09a4.12,4.12,0,0,0,3,.37A4.07,4.07,0,0,0,91.59,20a.86.86,0,0,0,.1-.16,4.09,4.09,0,0,0-1.54-5.52l-.07,0a4,4,0,0,0-2-.52c-.45-.22-.92-.43-1.39-.62A27.5,27.5,0,0,0,73,11.23a28.72,28.72,0,0,0-3.23.59A1,1,0,0,0,69.09,13a1,1,0,0,0,1.18.72,24.08,24.08,0,0,1,3-.54A25.13,25.13,0,0,1,85.44,14.7a4.41,4.41,0,0,0-.89,1.07v0A4.15,4.15,0,0,0,84,17.71a21.89,21.89,0,0,0-16.8.58,4.16,4.16,0,0,0-2.09.55l-.06,0a4.11,4.11,0,0,0-1.46,1.5,22.29,22.29,0,0,0-2.78,2.35,22,22,0,0,0-4.46,6.43,4,4,0,0,0-1.75-1,3.89,3.89,0,0,0-1.39-.13,25.88,25.88,0,0,1,1.71-3.21,25.32,25.32,0,0,1,8.65-8.38,2.21,2.21,0,0,0,.5.21,2.13,2.13,0,0,0,1.61-.21l0,0a2.12,2.12,0,0,0,1-1.27,2.15,2.15,0,0,0-.21-1.62h0a2.1,2.1,0,0,0-1.29-1,2.15,2.15,0,0,0-1.62.21l0,0a2.12,2.12,0,0,0-1,2A27.2,27.2,0,0,0,50.63,29.25a4,4,0,0,0-1.05,1.82h0a4,4,0,0,0,0,2.1,27.25,27.25,0,0,0,5.1,21.55,4,4,0,0,0-1.66,1h0a4.11,4.11,0,0,0-.82,1.18c-.54-.69-1-1.4-1.52-2.14a30,30,0,0,1-3.31-6.9A4.09,4.09,0,0,0,47.3,46a4.17,4.17,0,0,0-.88-1.65A30.53,30.53,0,0,1,53.5,18a4.06,4.06,0,0,0,1.58-1l.05-.06a4.17,4.17,0,0,0,.93-1.52A30.36,30.36,0,0,1,74.51,7.77a4.05,4.05,0,0,0,1.81.42,4.11,4.11,0,0,0,1.81-.42A30.21,30.21,0,0,1,88,10a30.57,30.57,0,0,1,9.9,6.62,1,1,0,1,0,1.39-1.39A32.33,32.33,0,0,0,80,6a4,4,0,0,0,.45-1.86,3.91,3.91,0,0,0-.27-1.46l1.26.16a36.7,36.7,0,0,1,5,1.06,1,1,0,0,0,1.21-.66A1,1,0,0,0,86.9,2,39.73,39.73,0,0,0,81.68.85C80.57.7,79.45.59,78.32.53a4,4,0,0,0-2-.53,4.08,4.08,0,0,0-2,.53,38.06,38.06,0,0,0-9.49,1.74,1,1,0,1,0,.59,1.86,37,37,0,0,1,5.38-1.27c.56-.08,1.13-.16,1.7-.22A4.18,4.18,0,0,0,72.66,6a32.41,32.41,0,0,0-16.59,6.87,4.06,4.06,0,0,0-1-1.63h0a3.94,3.94,0,0,0-1.21-.84,35.43,35.43,0,0,1,6.39-4.13,1,1,0,0,0-.87-1.75,38.17,38.17,0,0,0-8.3,5.66,4.16,4.16,0,0,0-1.8,1.06h0A4.07,4.07,0,0,0,48.23,13a38,38,0,0,0-5.83,8.64,2.05,2.05,0,0,0-.91.27,2.1,2.1,0,0,0-1,1.25s0,.06,0,.08a2.15,2.15,0,0,0,.22,1.58l0,0a2.12,2.12,0,0,0,1.22.94l.09,0a2.12,2.12,0,0,0,1.57-.22,2.15,2.15,0,0,0,1-1.3,2.11,2.11,0,0,0-.21-1.62,2.83,2.83,0,0,0-.2-.28,35.57,35.57,0,0,1,4.24-6.63A4.12,4.12,0,0,0,49.28,17a3.93,3.93,0,0,0,1.63,1,32.36,32.36,0,0,0-7.08,20.24A31.92,31.92,0,0,0,44.19,43a4.13,4.13,0,0,0-1.91.05,4,4,0,0,0-1.34.64,36.21,36.21,0,0,1-.16-9.83,34.13,34.13,0,0,1,.77-4.24,1,1,0,0,0-.73-1.18,1,1,0,0,0-1.18.72,39.5,39.5,0,0,0-.82,4.47,40.14,40.14,0,0,0-.27,4.55,37.48,37.48,0,0,0,.82,7.83,3.87,3.87,0,0,0,0,2,.53.53,0,0,0,0,.12,4,4,0,0,0,1,1.73c.27.84.57,1.66.9,2.47a37.67,37.67,0,0,0,7.89,12.11,1,1,0,0,0,1.4-1.37,35.85,35.85,0,0,1-7.47-11.48l-.21-.51A3.86,3.86,0,0,0,44.34,51ZM86.23,16.78a.41.41,0,0,0,0-.09,2.14,2.14,0,0,1,1.27-1,2.11,2.11,0,0,1,1.55.18l.12.06a2.16,2.16,0,0,1,.94,1.27A2.13,2.13,0,0,1,90,18.86h0a2.18,2.18,0,0,1-1.3,1A2.09,2.09,0,0,1,87,19.64h0a2.09,2.09,0,0,1-1-1.29A2.12,2.12,0,0,1,86.23,16.78Zm-21.13,5a2.15,2.15,0,0,1,1-1.27l0,0a2.13,2.13,0,0,1,2.91.79h0a2.15,2.15,0,0,1,.21,1.62,2.08,2.08,0,0,1-1,1.27l0,0a2.15,2.15,0,0,1-1.62.21,2.09,2.09,0,0,1-1.29-1h0A2.15,2.15,0,0,1,65.1,21.82ZM51.47,31.61a.29.29,0,0,0,0-.09,2.13,2.13,0,0,1,4.11,1.15A2.12,2.12,0,0,1,53,34.19l-.08,0a2.14,2.14,0,0,1-1.23-.94l0,0A2.16,2.16,0,0,1,51.47,31.61ZM54.4,57.12a2.12,2.12,0,0,1,1.51-.63,2.1,2.1,0,0,1,1.5.63h0A2.13,2.13,0,0,1,58,58.63a2.16,2.16,0,0,1-.58,1.46s0,0,0,0a2.15,2.15,0,0,1-3,0,2.15,2.15,0,0,1-.62-1.51,2.13,2.13,0,0,1,.62-1.5ZM74.81,2.58A2.08,2.08,0,0,1,76.31,2a2.16,2.16,0,0,1,1.51.62h0a2.09,2.09,0,0,1,.62,1.5,2.13,2.13,0,0,1-.58,1.47l0,0a2.16,2.16,0,0,1-1.51.62,2.07,2.07,0,0,1-1.5-.62,2.12,2.12,0,0,1-.63-1.51A2.1,2.1,0,0,1,74.81,2.58Zm-24.14,13a2.11,2.11,0,0,1-.62-1.51,2.09,2.09,0,0,1,.62-1.5h0A2.13,2.13,0,0,1,52.18,12a2.1,2.1,0,0,1,1.5.63h0a2.14,2.14,0,0,1,.63,1.51,2.17,2.17,0,0,1-.58,1.47l0,0a2.14,2.14,0,0,1-3,0ZM42.32,48.93l0,0a2.16,2.16,0,0,1-1-1.29h0A2.12,2.12,0,0,1,42.79,45a2.08,2.08,0,0,1,1.61.22h0a2.14,2.14,0,0,1,1,1.29,2.11,2.11,0,0,1-.22,1.62h0a2.1,2.1,0,0,1-1.29,1h0A2.12,2.12,0,0,1,42.32,48.93Z" /><path class="cls-1" d="M5.42,89C2.31,89,0,86.83,0,84s2.31-4.72,5.42-4.72h5.76l-.57.73H5.42C3,80,.84,81.5.84,84.08s2.16,4.15,5,4.15h5.34l-.57.72Z" /><path class="cls-1" d="M23.1,89,19,85.46H13V89h-.84v-4.2H19c2,0,3.59-.69,3.59-2.3S21.11,80,19,80H12.09l.58-.73H19.3c2.29,0,4.19.93,4.19,3.09,0,1.85-1.44,2.83-3.57,2.9L24.27,89Z" /><path class="cls-1" d="M35.58,79.3h.85v5.44q0,4.37-5.37,4.36c-4.15,0-5.94-1.45-5.94-4.36V79.3H26v5.44c0,2.49,1.48,3.64,5.08,3.64,3.35,0,4.53-1.15,4.53-3.64V79.3Z" /><path class="cls-1" d="M37.92,89c-.26,0-.45-.13-.45-.39a.51.51,0,0,1,.2-.41L47.31,80h-10l.56-.73H48.22c.26,0,.48.14.48.4a.47.47,0,0,1-.22.4l-9.65,8.12H49.1l-.53.72Z" /><path class="cls-1" d="M62.39,86.47,60.47,89H55.63a7,7,0,0,1-2.32-.38,5.78,5.78,0,0,1-1.84-1A4.93,4.93,0,0,1,50.26,86a4.47,4.47,0,0,1-.44-2,4.24,4.24,0,0,1,.44-1.92,4.74,4.74,0,0,1,1.21-1.5,5.66,5.66,0,0,1,1.84-1,7.84,7.84,0,0,1,2.32-.33h6.76l-1.92,2.5H55.63a3.37,3.37,0,0,0-1.12.18,2.59,2.59,0,0,0-.9.48,2.25,2.25,0,0,0-.59.74,2.17,2.17,0,0,0-.21,1,2.14,2.14,0,0,0,.21,1,1.94,1.94,0,0,0,.59.72,2.57,2.57,0,0,0,.9.47,3.65,3.65,0,0,0,1.12.17Z" /><path class="cls-1" d="M70.17,79.14a9.47,9.47,0,0,1,5.29,1.2,4.95,4.95,0,0,1,0,7.57,9.52,9.52,0,0,1-5.29,1.19,9.5,9.5,0,0,1-5.29-1.19,5,5,0,0,1,0-7.57A9.47,9.47,0,0,1,70.17,79.14Zm0,7.46a16.83,16.83,0,0,0,1.91-.1,3.18,3.18,0,0,0,1.26-.37,1.64,1.64,0,0,0,.7-.75,3.88,3.88,0,0,0,0-2.52,1.55,1.55,0,0,0-.7-.75,3.37,3.37,0,0,0-1.26-.36,14.78,14.78,0,0,0-1.91-.1,14.62,14.62,0,0,0-1.9.1,3.37,3.37,0,0,0-1.26.36,1.55,1.55,0,0,0-.7.75,3.18,3.18,0,0,0-.21,1.26,3.21,3.21,0,0,0,.21,1.26,1.64,1.64,0,0,0,.7.75,3.18,3.18,0,0,0,1.26.37A16.64,16.64,0,0,0,70.17,86.6Z" /><path class="cls-1" d="M88.51,89.1a1.88,1.88,0,0,1-.57-.09,1.64,1.64,0,0,1-.63-.43l-5.91-5.3v5.66H78.69v-8a2.27,2.27,0,0,1,.14-.82,1.51,1.51,0,0,1,.36-.56,1.46,1.46,0,0,1,.52-.32,1.81,1.81,0,0,1,.61-.1,1.52,1.52,0,0,1,.55.1,2,2,0,0,1,.65.42L87.43,85V79.3h2.72v8a2.27,2.27,0,0,1-.14.82,1.64,1.64,0,0,1-.36.57,1.23,1.23,0,0,1-.52.32A1.87,1.87,0,0,1,88.51,89.1Z" /><path class="cls-1" d="M103.89,79.3,102,81.81H98.51V89h-3V81.81H91l1.93-2.51Z" /><path class="cls-1" d="M117.51,89h-4l-2.14-2.55h-4.59V89h-3V84h8.39a2.25,2.25,0,0,0,1.17-.29.9.9,0,0,0,.47-.79.94.94,0,0,0-.43-.85,2.19,2.19,0,0,0-1.21-.28H103.8l2-2.51h6.19a9.13,9.13,0,0,1,1.7.16,5.12,5.12,0,0,1,1.6.54,3.44,3.44,0,0,1,1.19,1,2.89,2.89,0,0,1,.47,1.7,3.36,3.36,0,0,1-.17,1.06,3,3,0,0,1-.5.91,3.09,3.09,0,0,1-.79.69,3.27,3.27,0,0,1-1.06.39l.55.48c.2.19.47.45.8.79Z" /><path class="cls-1" d="M125,79.14a9.41,9.41,0,0,1,5.28,1.2,4.94,4.94,0,0,1,0,7.57A9.52,9.52,0,0,1,125,89.1a9.5,9.5,0,0,1-5.29-1.19,4.95,4.95,0,0,1,0-7.57A9.45,9.45,0,0,1,125,79.14Zm0,7.46a16.51,16.51,0,0,0,1.9-.1,3.29,3.29,0,0,0,1.27-.37,1.57,1.57,0,0,0,.69-.75,3.72,3.72,0,0,0,0-2.52,1.48,1.48,0,0,0-.69-.75,3.48,3.48,0,0,0-1.27-.36,18.1,18.1,0,0,0-3.8,0,3.37,3.37,0,0,0-1.26.36,1.5,1.5,0,0,0-.7.75,3.17,3.17,0,0,0-.22,1.26,3.2,3.2,0,0,0,.22,1.26,1.59,1.59,0,0,0,.7.75,3.18,3.18,0,0,0,1.26.37A16.64,16.64,0,0,0,125,86.6Z" /><path class="cls-1" d="M144,86.47,142.05,89h-8.52V79.3h3v7.17Z" /></g></g></g></svg>
      </div>
      <!-- Loading dots -->
      <div class="loading-dots">
        <span class="dot" />
        <span class="dot" />
        <span class="dot" />
      </div>
    </div>
    <!-- LOADING SPINNER IF SLOW -->
    <div v-if="longLoad && !isInitError && !cognitoError" class="w-full h-full mt-3 flex flex-col">
      <LoadingSpinner class="mt-52" />
    </div>
    <!-- INIT ERROR MESSAGE -->
    <div
      v-if="isInitError || cognitoError"
      class="error-state flex flex-col justify-center items-center w-full my-16"
    >
      <font-awesome-icon icon="fa-regular fa-circle-exclamation" class="error-icon m-1 h-10 w-10" />
      <h3 class="error-title text-secondary dark:text-secondary-200 py-2 text-2xl font-semibold">
        Uh oh...
      </h3>
      <p class="error-subtitle">
        Something went wrong.
      </p>
      <div class="flex flex-col sm:flex-row gap-3 my-5 items-center">
        <VButton
          @click="$emit('retry')"
          label="Try Again"
          uppercase
        />
        <VButton
          @click="clearAndReload"
          label="Clear Cache & Reload"
          color="secondary"
          outlined
          uppercase
        />
      </div>
      <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">
        If this keeps happening after an update, try "Clear Cache &amp; Reload".
      </p>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/Loading/LoadingSpinner/LoadingSpinner.vue"
import VButton from "@/components/Buttons/Button/VButton.vue"

export default {
  name: "AppLoadingIndicator",
  components: {
    LoadingSpinner,
    VButton
  },
  props: {
    longLoad: {
      type: Boolean,
      default: false
    },
    isInitError: {
      type: Boolean,
      default: false
    },
    cognitoError: {
      type: Boolean,
      default: false
    }
  },
  emits: ["retry"],
  computed: {
    loadingContainerClass() {
      let classes = ""
      if (this.longLoad || this.isInitError || this.cognitoError) classes += " "
      else classes += "loading-splash "
      if (this.longLoad && !this.isInitError && !this.cognitoError) classes += "h-load "
      else classes += "h-dfull"
      return classes
    }
  },
  methods: {
    clearAndReload() {
      // Clear all stored state that might be stale
      try { localStorage.clear() } catch (e) { /* ignore */ }
      try { sessionStorage.clear() } catch (e) { /* ignore */ }

      // Clear all cookies
      document.cookie.split(';').forEach(c => {
        const name = c.split('=')[0].trim()
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
      })

      // Hard reload bypassing cache
      window.location.reload()
    }
  }
}
</script>

<style scoped>
#loading_container {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-splash {
  background: linear-gradient(-45deg, #182B61, #3a559e, #4c6abd, #2A4794);
  background-size: 400% 400%;
  animation: gradientShift 8s ease infinite;
}

/* ── App loading splash screen ─────────────────── */
[data-theme="dark"] .loading-splash {
  background: linear-gradient(-45deg, #050a10, #0c111b, #0a1628, #080e18);
}

.splash-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

#svg-loading {
  width: 400px;
  fill: white;
  animation: logoEntrance 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  filter: drop-shadow(0 0 30px rgba(255, 255, 255, 0.15));
}



/* Loading dots */
.loading-dots {
  display: flex;
  gap: 8px;
  animation: dotsEntrance 0.5s ease-out 0.6s both;
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  animation: dotPulse 1.4s ease-in-out infinite;
}
.dot:nth-child(2) { animation-delay: 0.2s; }
.dot:nth-child(3) { animation-delay: 0.4s; }

/* ── Keyframes ──────────────────────────────────── */
@keyframes gradientShift {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes logoEntrance {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes dotsEntrance {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes dotPulse {
  0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }
  40%           { opacity: 1;   transform: scale(1.2); }
}

@media screen and (max-width: 600px) {
  #svg-loading {
    width: 70vw;
  }
}

/* ── Error state ────────────────────────────────── */
.error-state {
  animation: logoEntrance 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.error-icon {
  /* color: rgba(255, 255, 255, 0.7); */
  filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.2));
}
.error-title {
  /* color: rgba(255, 255, 255, 0.95); */
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.15);
}
</style>
